<app-skill-builder-select-list
	[mainTitle]="page.title"
	[options]="options"
	[custom]="custom"
	[next]="next"
>
</app-skill-builder-select-list>
